import { RedirectSourceEnum } from '../redirect-source-enum';

export const environment = {
  production: true,
  environment: 'production',

  // the Application id for this specific app
  authAppId: 'jXRK8Q3ArSiUU4-pOOgk1LLNWh51DuVIZrcdpe8Z7Bg',

  // the successful login return url
  authRedirectURI: 'https://portfolio.reconcept.nl/login/success/',
  // authRedirectURI: 'https://portfolio.reconcept.nl/login/success/',

  // the RedirectSource corresponding with backend
  authRedirectSource: RedirectSourceEnum.PORTFOLIO,

  // the requested grant scope
  authScope: 'user portfolio',

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept',
  canChangeBE: false,

  bugsnagApiKey: 'd4948bc3c3690da8470e18c6ecc91cb4',

  applicationName: 'Portfolio',
};
